import React from 'react'
import { ListPanel } from '@sukiai/components'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'

const PatientNotesContainer = ({
  type,
  title,
  loading,
  notes,
  count,
  openNoteTypeSelection,
  handleClick,
  calcheight
}) => {
  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.SMALL_LIST_PANEL_WIDTH})`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.CRAMPED_LIST_PANEL_WIDTH})`
  })

  return (
    <ListPanel
      type={type}
      title={title}
      loading={loading}
      count={count}
      notes={notes}
      handleClick={handleClick}
      calcheight={calcheight}
      openNoteTypeSelection={openNoteTypeSelection}

      isSmallWindow={isSmallWindow}
      isCrampedWindow={isCrampedWindow}
    />
  )
}

export default PatientNotesContainer
